import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationsStagesPlanWorksStaffPayments(companyId, regulationId, stageId, planWorkId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS].getRegulationsStagesPlanWorksStaffPayments,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
			},
		},
	)
}
function getRegulationsStagesPlanWorksStaffPaymentPreview(companyId, regulationId, stageId, planWorkId, staffPaymentId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS].getRegulationsStagesPlanWorksStaffPaymentPreview,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
				staffPaymentId,
			},
		},
	)
}
function getRegulationsStagesPlanWorksStaffPaymentPopup(companyId, regulationId, stageId, planWorkId, staffPaymentId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS].getRegulationsStagesPlanWorksStaffPaymentPopup,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
				staffPaymentId,
			},
		},
	)
}

function createRegulationsStagesPlanWorksStaffPayment(companyId, regulationId, stageId, planWorkId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS].createRegulationsStagesPlanWorksStaffPayment, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
		},
		...data,
	})
}

function getRegulationsStagesPlanWorksStaffPayment(companyId, regulationId, stageId, planWorkId, staffPaymentId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS].getRegulationsStagesPlanWorksStaffPayment, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			staffPaymentId,
		},
	})
}

function patchRegulationsStagesPlanWorksStaffPayment(companyId, regulationId, stageId, planWorkId, staffPaymentId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS].patchRegulationsStagesPlanWorksStaffPayment, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			staffPaymentId,
		},
		...data,
	})
}

function putRegulationsStagesPlanWorksStaffPayment(companyId, regulationId, stageId, planWorkId, staffPaymentId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS].putRegulationsStagesPlanWorksStaffPayment, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			staffPaymentId,
		},
		...data,
	})
}

function deleteRegulationsStagesPlanWorksStaffPayment(companyId, regulationId, stageId, planWorkId, staffPaymentId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS].deleteRegulationsStagesPlanWorksStaffPayment, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			staffPaymentId,
		},
	})
}

export default {
	getRegulationsStagesPlanWorksStaffPayments,
	getRegulationsStagesPlanWorksStaffPaymentPopup,
	getRegulationsStagesPlanWorksStaffPaymentPreview,
	getRegulationsStagesPlanWorksStaffPayment,
	patchRegulationsStagesPlanWorksStaffPayment,
	putRegulationsStagesPlanWorksStaffPayment,
	createRegulationsStagesPlanWorksStaffPayment,
	deleteRegulationsStagesPlanWorksStaffPayment,
}
